import { useEffect } from "react";
import usePixiApp from "./usePixiApp";

const useTick = (onTick: (timeDelta: number) => void) => {
  const app = usePixiApp();
  useEffect(() => {
    const handleTick = function () {
      onTick(app.ticker.deltaMS / 1000);
    };
    app.ticker.add(handleTick);
    return () => {
      app.ticker.remove(handleTick);
    };
  });
};

export default useTick;
